import { render, staticRenderFns } from "./BackgroundJobPage.vue?vue&type=template&id=01b203dc&scoped=true&"
import script from "./BackgroundJobPage.vue?vue&type=script&lang=js&"
export * from "./BackgroundJobPage.vue?vue&type=script&lang=js&"
import style0 from "./BackgroundJobPage.vue?vue&type=style&index=0&id=01b203dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b203dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01b203dc')) {
      api.createRecord('01b203dc', component.options)
    } else {
      api.reload('01b203dc', component.options)
    }
    module.hot.accept("./BackgroundJobPage.vue?vue&type=template&id=01b203dc&scoped=true&", function () {
      api.rerender('01b203dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Manda/BackgroundJobPage.vue"
export default component.exports